import React from "react";
import { logger } from "../../Logger";
import { Radio, RadioGroup } from "@fluentui/react-components";
import { Constants } from "../../common/constants";
import { TCTeamsFxContext } from "../TCTeamsContext";

interface ConfigurationProps {
  configuration: any;
  updateDataPrivacy: (key: string, val: boolean) => void;
}

const DigitalProductExcellence: React.FunctionComponent<ConfigurationProps> = ({
  configuration,
  updateDataPrivacy,
}) => {
  const teamsContext = React.useContext(TCTeamsFxContext);
  const i18n = teamsContext.i18n;
  const getUserTelemetryDefaultValue = (consentKey: string) => {
    logger.logTrace(`Entered ${getUserTelemetryDefaultValue.name}`);
    let retVal: string = "";
    if (configuration) {
      if (consentKey in configuration) {
        const userTelemetryOptIn: any = configuration[consentKey];
        if (userTelemetryOptIn !== null) {
          if (userTelemetryOptIn === true) {
            retVal = Constants.accept;
          } else {
            retVal = Constants.decline;
          }
        }
      }
    }
    logger.logTrace(`Exit ${getUserTelemetryDefaultValue.name}`);
    return retVal;
  };

  return (
    <>
      <div id="dpe_consent" className="data-privacy-consent-section">
        <div>
          <h3> {i18n.DigitalProductExperience} </h3>
          <p> {i18n.DepPara_1} </p>
          <p>
            {i18n.DepPara_2}{" "}
            <b>
              <a
                href="https://www.sw.siemens.com/en-US/trust-center/digital-product-experience/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n.SiemensTrustCenter}
              </a>
            </b>
          </p>
          <p> {i18n.DepChangeConsent} </p>
          <div>
            <RadioGroup
              layout="horizontal"
              defaultValue={getUserTelemetryDefaultValue(
                Constants.userDigitalProductTelemetryOptIn
              )}
            >
              <Radio
                id="rad_dpe_accept"
                value={Constants.accept}
                label={i18n.AgreeText}
                onChange={() =>
                  updateDataPrivacy(
                    Constants.userDigitalProductTelemetryOptIn,
                    true
                  )
                }
              />
              <Radio
                id="rad_dpe_decline"
                value={Constants.decline}
                label={i18n.DeclineText}
                onChange={() =>
                  updateDataPrivacy(
                    Constants.userDigitalProductTelemetryOptIn,
                    false
                  )
                }
              />
            </RadioGroup>
          </div>
        </div>
      </div>
    </>
  );
};

export default DigitalProductExcellence;
